import { Routes } from '@angular/router';

export const EMPRESA_ROUTES: Routes = [
  {
    path: 'listar',
    loadComponent: () =>
      import('./listar/empresa-listar.component')
        .then(m => m.EmpresaListarComponent)
  },
  {
    path: 'crear',
    loadComponent: () =>
      import('./crear/empresa-crear.component')
        .then(m => m.EmpresaCrearComponent)
  },
  {
    path: 'editar/:id',
    loadComponent: () =>
      import('./editar/editar-empresa.component')
        .then(m => m.EditarEmpresaComponent)
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./detalle/empresa-detalle.component')
        .then(m => m.EmpresaDetalleComponent)
  }
];
